// extracted by mini-css-extract-plugin
export default {"commentRow":"OrderEditDetails_commentRow__+-Dhw"};